namespace GeniuzPOS.InitialData {
    export interface PsCreditCardRow {
        Id?: number;
        CreditCardType?: string;
        CreditCardName?: string;
        ProdImageLink?: string;
        IsActive?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PsCreditCardRow {
        export const idProperty = 'CreditCardType';
        export const nameProperty = 'CreditCardName';
        export const localTextPrefix = 'InitialData.PsCreditCard';
        export const lookupKey = 'InitialData.PsCreditCard';

        export function getLookup(): Q.Lookup<PsCreditCardRow> {
            return Q.getLookup<PsCreditCardRow>('InitialData.PsCreditCard');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทบัตรเครดิต:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทบัตรเครดิต:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทบัตรเครดิต:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:ประเภทการรับเงิน,คูปอง:ประเภทบัตรเครดิต:Modify';

        export declare const enum Fields {
            Id = "Id",
            CreditCardType = "CreditCardType",
            CreditCardName = "CreditCardName",
            ProdImageLink = "ProdImageLink",
            IsActive = "IsActive",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
